/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentCheckSummaryDto } from './DeploymentCheckSummaryDto';
import {
    DeploymentCheckSummaryDtoFromJSON,
    DeploymentCheckSummaryDtoFromJSONTyped,
    DeploymentCheckSummaryDtoToJSON,
} from './DeploymentCheckSummaryDto';

/**
 * 
 * @export
 * @interface DeploymentCheckSummariesDto
 */
export interface DeploymentCheckSummariesDto {
    /**
     * The summary per dat.
     * @type {Array<DeploymentCheckSummaryDto>}
     * @memberof DeploymentCheckSummariesDto
     */
    checks: Array<DeploymentCheckSummaryDto>;
}

/**
 * Check if a given object implements the DeploymentCheckSummariesDto interface.
 */
export function instanceOfDeploymentCheckSummariesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "checks" in value;

    return isInstance;
}

export function DeploymentCheckSummariesDtoFromJSON(json: any): DeploymentCheckSummariesDto {
    return DeploymentCheckSummariesDtoFromJSONTyped(json, false);
}

export function DeploymentCheckSummariesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentCheckSummariesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'checks': ((json['checks'] as Array<any>).map(DeploymentCheckSummaryDtoFromJSON)),
    };
}

export function DeploymentCheckSummariesDtoToJSON(value?: DeploymentCheckSummariesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'checks': ((value.checks as Array<any>).map(DeploymentCheckSummaryDtoToJSON)),
    };
}

